import React from 'react';
import Logo from '../../assets/images/logo.png';
import packageJson from '../../../package.json';
import {
  BoxContainer,
  ContentContainer,
  BoxHeader,
  LogoImage,
  BoxContent,
  CopyrightBox,
  UpperText,
  Text,
} from './StyledComponents';

const LoginBox = props => {
  const { children } = props;
  return (
    <BoxContainer>
      <ContentContainer>
        <BoxHeader>
          <LogoImage src={Logo} />
        </BoxHeader>
        <BoxContent>{children}</BoxContent>
      </ContentContainer>
      <CopyrightBox>
        <UpperText>Version:&nbsp;&nbsp;{packageJson.version}</UpperText>
        <Text>Copyright@ {(new Date().getFullYear())} SIRP</Text>
        <Text>All rights reserved</Text>
      </CopyrightBox>
    </BoxContainer>
  );
};
export default LoginBox;
